import React, { useEffect, useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import { useHistory } from "react-router-dom";
import { translate } from "react-switch-lang";
import { toast } from "react-toastify";
import { Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import SweetAlert from "sweetalert2";
import CategoryCard from "./category-card/categoryCard";
import { useHttpClient } from "../../security/hooks/axiosProvider";
import styles from "./categories.module.scss";
import AddCategory from "./add-category/addCategory";
import { CategoryDto } from "../../models/categoryDto";


const Categories: React.FC<{ t: (key: string) => {} }> = props => {
  toast.configure();
  const pathFolder = "/Mediatheque/Categories/";
  let history = useHistory();

  const [editCategoryData, setEditCategoryData] = useState<CategoryDto>(new CategoryDto());
  const [isOnCreate, setIsOnCreate] = useState<boolean>(false);
  const [formValidation, setFormValidation] = useState<boolean>(false);
  const [isShowDropZone, setIsShowDropZone] = useState<boolean>(true);
  const [modal, setModal] = useState<boolean>(false);

  const httpClient = useHttpClient(false);

  const [setBookmarklist] = useState<CategoryDto[]>([]);
  const [listFilterCategory, setListFilterCatgory] = useState<CategoryDto[]>([]);

  useEffect(() => {
    if (!sessionStorage.getItem("sessionObject")) {
      sessionStorage.setItem("sessionObject", JSON.stringify("visitor"));
      httpClient.current?.post("/statistic_visitor", {}).then();
    }
    httpClient.current?.get("/category/child", { params: { pathFolder: pathFolder } }).then(response => {
      setListFilterCatgory(response.data);
    });
  }, [httpClient]);

  const removeCategory = (categoryId: number) => {
    SweetAlert.fire({
      title: props.t("category.message_confirmation_delete_category"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: String(props.t("button_delete")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
      width: window.outerWidth > 600 ? "100%" : "90%",
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/category/" + categoryId).then(response => {
          toast.success(props.t("message_toastr_delete"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          httpClient.current?.get("/category/child", { params: { pathFolder: pathFolder } }).then(response => {
            setListFilterCatgory(response.data);
          });
        });
      } else {
      }
    });
  };
  const editCategory = (data: CategoryDto) => {
    toggle(false);
    setEditCategoryData(data);
  };
  const toggle = (isOnCreat: boolean) => {
    if (isOnCreat) {
      setIsOnCreate(isOnCreat);
      setIsShowDropZone(true);
      setFormValidation(false);
    } else {
      setIsShowDropZone(false);
      setIsOnCreate(isOnCreat);
      setFormValidation(true);
    }

    setModal(!modal);
  };

  const handleClickCategory = (data: CategoryDto) => {
    history.push("/category/" + data.titleAnglais + "/" + data.categoryId, {
      update: true,
      title: data.titleAnglais,
    });
  };

  
  return (
    <>
      <Container fluid>
        <Row>
          <Col sm="12">
            {/* <CardHeader className={styles["category-card-header"]}>
              <FormSearchCategories toggle={toggle} handleSearch={handleSearch}></FormSearchCategories>
            </CardHeader> */}

            <Row>
              <Col className="p-0" xl="12">
                <div className={styles["categories-container"]}>
                  {listFilterCategory.length > 0 ? (
                    listFilterCategory.map((data: CategoryDto, index) => {
                      return <CategoryCard data={data} handleClickCategory={handleClickCategory} editCategory={editCategory} removeCategory={removeCategory} key={index} />;
                    })
                  ) : (
                    <div>
                      <span>{props.t("category.message_no_category")}</span>
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <Modal className={styles["modal_add_category_wrapper"]} isOpen={modal} size="lg">
              <ModalHeader toggle={() => toggle(false)}>{isOnCreate ? props.t("category.title_create_category") : props.t("category.title_update_category")}</ModalHeader>
              <ModalBody>
                <AddCategory
                  isShowDropZone={isShowDropZone}
                  setIsShowDropZone={setIsShowDropZone}
                  modal={modal}
                  isOnCreate={isOnCreate}
                  formValidation={formValidation}
                  toggle={toggle}
                  setBookmarklist={setBookmarklist}
                  setListFilterCatgory={setListFilterCatgory}
                  editCategoryData={editCategoryData}
                ></AddCategory>
              </ModalBody>
            </Modal>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default translate(Categories);
